module.exports = __webpack_public_path__ + "static/media/The-West-Subscription_devicecomp_min.a18aa6d3.webp";